import Text from 'components/Text'
import { useTheme } from 'modules/styles'
import React from 'react'

export default function Paragraph (propParams) {
  const theme = useTheme()
  const {
    style,
    props
  } = Text.getStyleAndProps(
    {
      fs: 'body',
      my: 0.5,
      d: 'block',
      ...propParams
    },
    theme
  )
  return (
    <p {...props} style={style} />
  )
}
